// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const COMERCIAL = {
  mensaje: '¿Qué necesitas en Comercial?',
  opciones: [
    {
      boton: 'Cotización',
      respuesta: 'Ve a Comercial → Cotizaciones. Puedes crear, modificar y aprobar cotizaciones desde esa pantalla.',
    },
    {
      boton: 'Orden de pedido',
      respuesta: 'Las órdenes de pedido se encuentran en Comercial → Pedidos. Desde ahí puedes registrar y hacer seguimiento de cada pedido.',
    },
    {
      boton: 'Facturación',
      respuesta: 'Las facturas se emiten desde Comercial → Facturación. Puedes generar facturas a partir de un pedido o de forma directa.',
    },
    {
      boton: 'Guía de remisión',
      respuesta: 'Las guías de remisión están en Comercial → Guías. Se pueden generar desde un despacho o de forma independiente.',
    },
  ],
}
